/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block}.buttongroup[_ngcontent-%COMP%]{margin-top:20px}.fullwidth[_ngcontent-%COMP%]{max-width:100%}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/ui/requestnotes/requestnotes.component.css.shim.ngstyle.js.pre-build-optimizer.js